module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"back":"Zurück","inventory":"Inventur"},"en":{"back":"Back","inventory":"Inventory"}}')
  delete Component.options._Ctor
}
